<template>
	<Dialog :open="true" @update:open="$emit('close')">
		<DialogContent class="sm:max-w-md">
			<DialogHeader class="mb-6">
				<DialogTitle class="text-2xl">eSIM QR Code</DialogTitle>
				<DialogDescription v-if="loading" class="text-base"> Loading QR code... </DialogDescription>
			</DialogHeader>

			<div v-if="qrCode" class="flex flex-col items-center space-y-6">
				<div class="rounded-lg bg-white p-4 shadow-sm dark:bg-gray-800">
					<img :src="qrCode" alt="eSIM QR Code" class="max-h-[300px] w-auto" />
				</div>
				<div class="w-full space-y-2">
					<label class="text-sm font-medium text-gray-700 dark:text-gray-300">Email Address</label>
					<input
						v-model="email"
						type="email"
						placeholder="Enter email address"
						class="w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-gray-900 transition-colors placeholder:text-gray-500 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-400"
					/>
				</div>
			</div>
			<div v-else-if="!loading" class="py-4 text-center text-red-500">No QR code is available for this eSIM.</div>

			<DialogFooter class="mt-6 flex justify-between gap-4 sm:justify-between">
				<DialogClose as="button" class="jmiBtn btnLg red">
					<span class="fa-light fa-xmark mr-2"></span>
					Close
				</DialogClose>
				<button v-if="qrCode" class="jmiBtn btnLg green" :disabled="!email || sendingEmail" @click="sendEmail">
					<span class="fa-light fa-paper-plane mr-2"></span>
					{{ sendingEmail ? 'Sending...' : 'Send QR Code' }}
				</button>
			</DialogFooter>
		</DialogContent>
	</Dialog>
</template>

<script>
import mobilesimsApi from '../scripts/mobilesims/mobilesims.api'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogClose
} from '@/components/ui/dialog'

export default {
	components: {
		Dialog,
		DialogContent,
		DialogDescription,
		DialogFooter,
		DialogHeader,
		DialogTitle,
		DialogClose
	},
	props: {
		simId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			qrCode: null,
			loading: true,
			email: '',
			sendingEmail: false
		}
	},
	mounted() {
		this.fetchQRCode()
	},
	methods: {
		fetchQRCode() {
			this.loading = true
			mobilesimsApi
				.getQrCode(this.simId)
				.then((response) => {
					if (response?.data?.qrCode?.data) {
						this.qrCode = response.data.qrCode.data
					}
				})
				.catch((error) => {
					console.error('Error fetching QR code:', error)
					this.$swal({
						title: 'Error',
						text: 'Failed to fetch QR code. Please try again.',
						icon: 'error'
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
		sendEmail() {
			if (!this.email) return

			this.sendingEmail = true
			mobilesimsApi
				.sendEsimEmail(this.simId, this.email)
				.then(() => {
					this.$swal({
						title: 'Success',
						text: 'QR code has been sent to the email address.',
						icon: 'success'
					}).then(() => {
						this.$emit('close')
					})
				})
				.catch((error) => {
					console.error('Error sending email:', error)
					this.$swal({
						title: 'Error',
						text: 'Failed to send email. Please try again.',
						icon: 'error'
					})
				})
				.finally(() => {
					this.sendingEmail = false
				})
		}
	}
}
</script>
